// extracted by mini-css-extract-plugin
export var tosLink = "_50-0";